import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { uid } from '@pixi/utils';
import { BaseImageResource } from './BaseImageResource.mjs';
import { settings } from '@pixi/settings';
var _SVGResource = /*#__PURE__*/function (_BaseImageResource) {
  _inherits(_SVGResource, _BaseImageResource);
  var _super = _createSuper(_SVGResource);
  function _SVGResource(sourceBase64, options) {
    var _this;
    _classCallCheck(this, _SVGResource);
    options = options || {};
    _this = _super.call(this, settings.ADAPTER.createCanvas());
    _this._width = 0;
    _this._height = 0;
    _this.svg = sourceBase64;
    _this.scale = options.scale || 1;
    _this._overrideWidth = options.width;
    _this._overrideHeight = options.height;
    _this._resolve = null;
    _this._crossorigin = options.crossorigin;
    _this._load = null;
    if (options.autoLoad !== false) {
      _this.load();
    }
    return _this;
  }
  _createClass(_SVGResource, [{
    key: "load",
    value: function load() {
      var _this2 = this;
      if (this._load) {
        return this._load;
      }
      this._load = new Promise(function (resolve) {
        _this2._resolve = function () {
          _this2.resize(_this2.source.width, _this2.source.height);
          resolve(_this2);
        };
        if (_SVGResource.SVG_XML.test(_this2.svg.trim())) {
          if (!btoa) {
            throw new Error("Your browser doesn't support base64 conversions.");
          }
          _this2.svg = "data:image/svg+xml;base64,".concat(btoa(unescape(encodeURIComponent(_this2.svg))));
        }
        _this2._loadSvg();
      });
      return this._load;
    }
  }, {
    key: "_loadSvg",
    value: function _loadSvg() {
      var _this3 = this;
      var tempImage = new Image();
      BaseImageResource.crossOrigin(tempImage, this.svg, this._crossorigin);
      tempImage.src = this.svg;
      tempImage.onerror = function (event) {
        if (!_this3._resolve) {
          return;
        }
        tempImage.onerror = null;
        _this3.onError.emit(event);
      };
      tempImage.onload = function () {
        if (!_this3._resolve) {
          return;
        }
        var svgWidth = tempImage.width;
        var svgHeight = tempImage.height;
        if (!svgWidth || !svgHeight) {
          throw new Error("The SVG image must have width and height defined (in pixels), canvas API needs them.");
        }
        var width = svgWidth * _this3.scale;
        var height = svgHeight * _this3.scale;
        if (_this3._overrideWidth || _this3._overrideHeight) {
          width = _this3._overrideWidth || _this3._overrideHeight / svgHeight * svgWidth;
          height = _this3._overrideHeight || _this3._overrideWidth / svgWidth * svgHeight;
        }
        width = Math.round(width);
        height = Math.round(height);
        var canvas = _this3.source;
        canvas.width = width;
        canvas.height = height;
        canvas._pixiId = "canvas_".concat(uid());
        canvas.getContext("2d").drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height);
        _this3._resolve();
        _this3._resolve = null;
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(_SVGResource.prototype), "dispose", this).call(this);
      this._resolve = null;
      this._crossorigin = null;
    }
  }], [{
    key: "getSize",
    value: function getSize(svgString) {
      var sizeMatch = _SVGResource.SVG_SIZE.exec(svgString);
      var size = {};
      if (sizeMatch) {
        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
      }
      return size;
    }
  }, {
    key: "test",
    value: function test(source, extension) {
      return extension === "svg" || typeof source === "string" && source.startsWith("data:image/svg+xml") || typeof source === "string" && _SVGResource.SVG_XML.test(source);
    }
  }]);
  return _SVGResource;
}(BaseImageResource);
var SVGResource = _SVGResource;
SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m;
SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i;
export { SVGResource };